import { FIRST_NAME_SCHEMA_FIELD_NAME, getFirstNameFormFieldSchema } from "../FirstNameFormField";
import { getLastNameFormFieldSchema, LAST_NAME_SCHEMA_FIELD_NAME } from "../LastNameFormField";
import {
  getMiddleNameFormFieldSchema,
  MIDDLE_NAME_SCHEMA_FIELD_NAME,
} from "../MiddleNameFormField";
import {
  getPreferredFirstNameFormFieldSchema,
  PREFERRED_FIRST_NAME_SCHEMA_FIELD_NAME,
} from "../PreferredFirstNameFormField";
import {
  getSuffixFormFieldSchema,
  SUFFIX_SCHEMA_FIELD_NAME,
} from "../SuffixFormField/SuffixFormField.schema";

export const getNameFormFieldsSchema = (fieldNames = {}) => {
  const {
    firstName = FIRST_NAME_SCHEMA_FIELD_NAME,
    middlename = MIDDLE_NAME_SCHEMA_FIELD_NAME,
    lastName = LAST_NAME_SCHEMA_FIELD_NAME,
    preferredFirstName = PREFERRED_FIRST_NAME_SCHEMA_FIELD_NAME,
    suffix = SUFFIX_SCHEMA_FIELD_NAME,
  } = fieldNames;

  return {
    [firstName]: getFirstNameFormFieldSchema(),
    [lastName]: getLastNameFormFieldSchema(),
    [middlename]: getMiddleNameFormFieldSchema(),
    [preferredFirstName]: getPreferredFirstNameFormFieldSchema(),
    [suffix]: getSuffixFormFieldSchema(),
  };
};
